import { appHttpRequest } from '@/utils/AppHttpRequest';
import { ciHttpRequest } from '@/utils/CiHttpRequest';
import { IPage, CIPage } from '@/types/FmsTypes';
import { IFullOrderSearch, IFullOrderFields } from './fullOrderTypes';
import { LONG_REQUEST_TIMEOUT } from '@/utils/constants';

class FullOrderService {
	// 供应链采购采退单
	async scmPPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/scm2/purchase/po/purchaseFormPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// 供应链销售销退单
	async scmSPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/scm2/sale/so/saleFormPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 云创采购采退
	async ciPPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-storage/purchase/formAll';
		return await ciHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 云创采购导出
	async ciPurchaseExport(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-storage/purchase/repairFormExportAllFms';
		return await ciHttpRequest.postFile<IPage<IFullOrderFields>>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 云创销售销退
	async ciSPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-storage/sale/formAll';
		return await ciHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 云创销售销退导出
	async ciSaleExport(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-storage/sale/repairFormExportAllFms';
		return await ciHttpRequest.postFile<IPage<IFullOrderFields>>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 云创维修单维修退单
	async ciRPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-analyze/repairFormAll';
		return await ciHttpRequest.postWithTimeout<CIPage<IFullOrderFields>>(apiUrl, searchVo, 30000);
	}

	// 云创销售销退导出
	async ciRepairExport(searchVo: IFullOrderSearch) {
		const apiUrl = '/ci-analyze/repairFormAll/export';
		return await ciHttpRequest.postFileWithTimeout<IPage<IFullOrderFields>>(apiUrl, searchVo, 180000);
	}

	// 云修采购采退
	async vrmPPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/vrm2/purchase/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 云修销售销退
	async vrmSPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/vrm2/sale/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 云修维修单维修退单
	async vrmRPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/vrm2/maintenance/repairFormAllPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 客车采购采退
	async bcmPPage(searchVo: IFullOrderSearch) {
		const apiUrl = 'bcm/purchase/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 客车销售销退
	async bcmSPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/bcm/sale/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 客车维修
	async bcmRPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/bcm/maintenance/repairFormAllPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 客车公交销售销退
	async bcmBSPage(searchVo: IFullOrderSearch) {
		const apiUrl = 'bcm/transit/sale/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}

	// 导出接口
	async detailExport(params: object) {
		const apiUrl = 'fms/bill/detailExport';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 导出接口
	async saleDetailExport(params: object) {
		const apiUrl = 'scm2/statistics/sale/fms/report/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 导出接口
	async purchaseDetailExport(params: object) {
		const apiUrl = 'scm2/purchase/po/fms/report/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 导出接口
	async vrmSaleDetailExport(params: object) {
		const apiUrl = '/vrm2/sale/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// 导出接口
	async vrmPurchaseDetailExport(params: object) {
		const apiUrl = '/vrm2/purchase/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// 客车维修导出接口
	async bcmRepairDetailExport(params: object) {
		const apiUrl = '/bcm/maintenance/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// 导出接口
	async vrmRepairDetailExport(params: object) {
		const apiUrl = '/vrm2/maintenance/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 导出接口
	async bcmSaleDetailExport(params: object) {
		const apiUrl = '/bcm/sale/saleFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// 导出接口
	async bcmPurchaseDetailExport(params: object) {
		const apiUrl = '/bcm/purchase/purFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// 导出接口
	async bcmTransitDetailExport(params: object) {
		const apiUrl = '/bcm/transit/sale/saleFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}

	// 对账单导出
	async scm2SimplificationExport(params: object) {
		const apiUrl = '/scm2/statistics/sale/fms/report/simplificationExport';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	
	// ngavrm-s采购
	async vrmNgaSPuchasePage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-s/vrm-sa/purchase/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-s采购导出接口
	async vrmNgaSPuchaseDetailExport(params: object) {
		const apiUrl = '/ngavrm-s/vrm-sa/purchase/purFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// ngavrm-s销售
	async vrmNgaSSalePage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-s/vrm-sa/sale/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-s销售导出接口
	async vrmNgaSSaleDetailExport(params: object) {
		const apiUrl = '/ngavrm-s/vrm-sa/sale/saleFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// ngavrm-s维修
	async vrmNgaSMaintainPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-s/vrm-sa/maintenance/repairFormAllPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-s维修导出接口
	async vrmNgaSMaintainDetailExport(params: object) {
		const apiUrl = 'ngavrm-s/vrm-sa/maintenance/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}


	// ngavrm-yh采购
	async vrmNgaYhPuchasePage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-yh/vrm-sa/purchase/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-yh采购导出接口
	async vrmNgaYhPuchaseDetailExport(params: object) {
		const apiUrl = '/ngavrm-yh/vrm-sa/purchase/purFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// ngavrm-yh销售
	async vrmNgaYhSalePage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-yh/vrm-sa/sale/formAll';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-yh销售导出接口
	async vrmNgaYhSaleDetailExport(params: object) {
		const apiUrl = '/ngavrm-yh/vrm-sa/sale/saleFormAll/export';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}
	// ngavrm-yh维修
	async vrmNgaYhMaintainPage(searchVo: IFullOrderSearch) {
		const apiUrl = '/ngavrm-yh/vrm-sa/maintenance/repairFormAllPage';
		return await appHttpRequest.post<IPage<IFullOrderFields>>(apiUrl, searchVo);
	}
	// ngavrm-yh维修导出接口
	async vrmNgaYhMaintainDetailExport(params: object) {
		const apiUrl = 'ngavrm-yh/vrm-sa/maintenance/repairFormExportAllFms';
		return await appHttpRequest.postFile<boolean>(apiUrl, params, { timeout: LONG_REQUEST_TIMEOUT });
	}



}

export const fullOrderService = new FullOrderService();
